import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_MODIFICAR_COORDENADES,
    AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS } from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = null;

const coordenades = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {

        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_INTRODUCCIO_MODIFICAR_COORDENADES: {
            const { coordenades } = action;
            if (coordenades === undefined) {
                return ESTAT_INICIAL;
            } else {
                return coordenades;
            }
        }

        case AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS:
            return action.avis.coordenades;

        default:
            return state;
    }
};

export default coordenades;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/dades/coordenades.js